// Helper function to safely format base64 and data URL images
// Mirrors the logic originally defined in App.js
const formatImageSrc = (imageData) => {
  if (!imageData || typeof imageData !== 'string') {
    return null;
  }

  // If it's already a complete data URL, return as-is
  if (imageData.startsWith('data:image/')) {
    return imageData;
  }

  // If it's an absolute URL (http/https), return as-is
  if (/^https?:\/\//i.test(imageData)) {
    return imageData;
  }

  // If it's just base64 data, add the data URL prefix
  // Check for valid base64 pattern (alphanumeric + / and = padding)
  if (imageData.length > 50 && /^[A-Za-z0-9+/]+=*$/.test(imageData.substring(0, 100))) {
    return `data:image/jpeg;base64,${imageData}`;
  }

  // For debugging: log invalid image data
  if (imageData.length > 10) {
    // eslint-disable-next-line no-console
    console.warn('formatImageSrc: Invalid image data format:', imageData.substring(0, 50) + '...');
  }

  // If data seems invalid, return null
  return null;
};

export default formatImageSrc;


